
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../../home/components/Footer';

export default function NotdienstPage() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleRequestClick = () => {
    navigate('/');
    setTimeout(() => {
      const contactSection = document.getElementById('kontakt');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
        window.dispatchEvent(new CustomEvent('preselect-service', { detail: 'Notdienst' }));
      }
    }, 100);
  };

  return (
    <div className="min-h-screen bg-white">
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <Link to="/">
            <img src="https://public.readdy.ai/ai/img_res/cd59830a-a811-4b8c-95fb-12d94d035ec5.png" alt="Elektro Tomasevic KG" className="h-10 sm:h-12 w-auto" />
          </Link>
          <a href="tel:+436991223301" className="bg-[#F4B942] text-[#1A2B4A] px-4 sm:px-6 py-2.5 sm:py-3 rounded-full font-semibold hover:bg-[#e5a832] transition-colors cursor-pointer whitespace-nowrap text-sm sm:text-base">
            <i className="ri-phone-fill mr-1 sm:mr-2"></i>
            <span className="hidden sm:inline">+43 699 122 333 01</span>
            <span className="sm:hidden">Anrufen</span>
          </a>
        </div>
      </nav>

      <main className="pt-24 sm:pt-32 pb-16 sm:pb-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <Link
            to="/"
            onClick={(e) => {
              e.preventDefault();
              navigate('/');
              setTimeout(() => {
                const el = document.getElementById('leistungen');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }, 100);
            }}
            className="inline-flex items-center text-[#1A2B4A] hover:text-[#F4B942] transition-colors mb-6 sm:mb-8 cursor-pointer text-sm sm:text-base"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Zurück zu allen Leistungen
          </Link>

          <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-3xl p-8 sm:p-12 mb-10 sm:mb-12">
            <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-red-500 rounded-2xl mb-5 sm:mb-6">
              <i className="ri-alarm-warning-fill text-white text-3xl sm:text-4xl"></i>
            </div>
            <h1 className="text-3xl sm:text-5xl font-bold text-[#1A2B4A] mb-3 sm:mb-4">24/7 Elektro-Notdienst</h1>
            <p className="text-base sm:text-xl text-gray-600">
              Schnelle Hilfe bei elektrischen Notfällen – rund um die Uhr für Sie da
            </p>
          </div>

          <div className="mb-10 sm:mb-12 space-y-4 sm:space-y-6">
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              Elektrische Notfälle können jederzeit auftreten und erfordern sofortiges Handeln. Ob Stromausfall,
              defekte Sicherungen, Kurzschlüsse oder andere elektrische Störungen – unser erfahrenes Notdienst-Team
              ist 24 Stunden am Tag, 7 Tage die Woche für Sie erreichbar.
            </p>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              Wir verstehen, dass elektrische Probleme nicht nur unangenehm, sondern auch gefährlich sein können.
              Deshalb garantieren wir Ihnen eine schnelle Reaktionszeit und professionelle Hilfe.
            </p>

            <div className="bg-[#1A2B4A] rounded-2xl p-6 sm:p-8 text-white">
              <h3 className="text-xl sm:text-2xl font-bold mb-4 flex items-center">
                <i className="ri-time-fill text-[#F4B942] mr-3 text-2xl sm:text-3xl"></i>
                Wann sollten Sie unseren Notdienst rufen?
              </h3>
              <ul className="space-y-3 text-white/90">
                {[
                  'Kompletter Stromausfall in Ihrer Wohnung oder Ihrem Gebäude',
                  'Defekte oder durchgebrannte Sicherungen',
                  'Kurzschlüsse und Funkenbildung',
                  'Brandgeruch oder Schmorgeruch aus Steckdosen oder Schaltern',
                  'Defekte Elektrogeräte, die eine Gefahr darstellen',
                  'Probleme mit der Elektroinstallation nach Unwettern',
                ].map((item, i) => (
                  <li key={i} className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-[#F4B942] mr-3 mt-1 shrink-0"></i>
                    <span className="text-sm sm:text-base">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              Unser Notdienst deckt ganz Wien und Umgebung ab. Nach Ihrem Anruf machen wir uns umgehend auf den Weg
              zu Ihnen. Wir führen eine umfassende Fehlerdiagnose durch und beheben das Problem fachgerecht.
            </p>

            <div className="bg-red-50 border-l-4 border-red-500 p-5 sm:p-6 rounded-r-xl">
              <p className="text-red-800 font-semibold flex items-start gap-3 text-sm sm:text-base">
                <i className="ri-error-warning-fill text-xl sm:text-2xl shrink-0 mt-0.5"></i>
                Bei akuter Gefahr (z.B. Feuer, starke Rauchentwicklung) rufen Sie bitte zuerst die Feuerwehr (122) und verlassen Sie das Gebäude!
              </p>
            </div>
          </div>

          <div className="bg-[#F8F9FB] rounded-2xl p-6 sm:p-8 text-center">
            <h3 className="text-xl sm:text-2xl font-bold text-[#1A2B4A] mb-3 sm:mb-4">Notfall? Wir sind für Sie da!</h3>
            <p className="text-gray-600 mb-5 sm:mb-6 text-sm sm:text-base">
              Kontaktieren Sie uns jederzeit – Tag und Nacht, auch an Wochenenden und Feiertagen.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
              <a
                href="tel:+436991223301"
                className="inline-flex items-center justify-center bg-red-500 text-white px-6 sm:px-8 py-4 rounded-xl font-bold text-base hover:bg-red-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill mr-2"></i>
                Jetzt anrufen
              </a>
              <button
                onClick={handleRequestClick}
                className="inline-flex items-center justify-center bg-[#F4B942] text-[#1A2B4A] px-6 sm:px-8 py-4 rounded-xl font-bold text-base hover:bg-[#e5a832] transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-send-fill mr-2"></i>
                Anfrage senden
              </button>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
